export default "__VITE_ASSET__BqfqQwh8__"